import { ProductBuilderState } from '../state'
import { Product, productDtoToProduct, ProductDto, productRead, productDtoToParameters } from '../../product'
import { takeLatest, put, call } from 'redux-saga/effects'
import { api } from '../../../core'
import { ProductBuilderAction } from '.'
import { productMock } from '../../product/api'

export const productBuilderProductSet = (state: ProductBuilderState, params: { product: Product, productParameterLabels: { [key: string]: string } }): ProductBuilderState => ({
    ...state, product: params.product, productParameterLabels: params.productParameterLabels
})

export function* productBuilderProductLoad(action: { type: ProductBuilderAction, params: { productId: string } }) {
    const productDto: ProductDto = yield call(api, productRead(action.params.productId))
    //const productDto: ProductDto = productMock
    const product = productDtoToProduct(productDto)
    const productParameters = productDtoToParameters(productDto)
    yield put({ type: 'PRODUCT_BUILDER_PRODUCT_SET', params: { product, productParameterLabels: productDto.parameters_labels } })
    yield put({ type: 'PRODUCT_BUILDER_PARAMETERS_SET', params: { productParameters } })
    yield put({ type: 'PRODUCT_BUILDER_COST_SET', params: { productConfiguration: product.configuration } })
    const typeParam = productParameters.find(it => it.key === 'types')
    if (product.configuration['types'] && product.configuration['types'].length && typeParam && typeParam.valueProvider && typeParam.valueProvider.list && typeParam.valueProvider.list.length) {
        const typeParamValueCurrent = typeParam.valueProvider.list.find(it => it.key === product.configuration['types'][0].key)
        if (typeParamValueCurrent && typeParamValueCurrent.constraints)
            yield put({ type: 'PRODUCT_BUILDER_PARAMETER_VALUE_DISABLED_SET', params: { productConfiguration: product.configuration, productParameterValueConstraints: typeParamValueCurrent.constraints } })
    }
}

export function* productBuilderProductLoadWatch() {
    yield takeLatest('PRODUCT_BUILDER_PRODUCT_LOAD', productBuilderProductLoad)
}

export const productBuilderDefaultProductSet = (state: ProductBuilderState, configDefault: object): ProductBuilderState => {
    const configDefaultClone = {...configDefault}
    return {...state, ...state.product.configuration = configDefaultClone}
}